<template>
  <section class="mt-12">
    <v-container>
      <v-row class="justify-center my-0">
        <v-col cols="12" lg="6">
          <div class="text-center">
            <h2 class="text-h4 font-weight-bold mb-4">
              The Perfect Way To Learn Photography
            </h2>
            <p class="text-body-1 mb-12">
              Learning can be the best photography investment you have ever made. Many of the photography masters became famous by learning from other masters.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-center my-0">
        <v-col cols="12" xl="8">
          <v-row class="align-center">
            <v-col
              :order="$vuetify.breakpoint.smAndUp ? 1 : null"
              cols="12"
              sm="6"
              md="5"
            >
              <v-img
                src="/images/learning/professional-critiques.jpg"
                alt=""
                aspect-ratio="1.7778"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="7">
              <v-icon x-large class="mb-3">fal fa-chalkboard-teacher</v-icon>
              <h3 class="text-h5 font-weight-bold mb-3">
                Professional Critiques
              </h3>
              <p class="mb-0 text-body-1">
                Photo critiques offer a deconstruction of your photo looking at lighting, colours, composition, sharpness (where relevant) and storytelling. They are great ways to get a new perspective on your photography.
              </p>
              <v-btn
                to="/learning/professional-critiques"
                nuxt
                class="mt-4 grey darken-4 white--text"
                depressed
                outlined
              >
                Find out more
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="align-center mt-12">
            <v-col cols="12" sm="6" md="5">
              <v-img
                src="/images/learning/community-reviews.jpg"
                alt=""
                aspect-ratio="1.7778"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="7">
              <v-icon x-large class="mb-3">fal fa-comments</v-icon>
              <h3 class="text-h5 font-weight-bold mb-3">
                Community Reviews
              </h3>
              <p class="mb-0 text-body-1">
                You would be surprised how much you learn yourself when digging into a photography deeply.  Comments on a photo really help the photographer. They can give confidence, offer suggestions and give ideas for future photos.
              </p>
              <v-btn
                to="/community-reviews"
                nuxt
                class="mt-4 grey darken-4 white--text"
                depressed
                outlined
              >
                View all
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="align-center mt-12">
            <v-col
              :order="$vuetify.breakpoint.smAndUp ? 1 : null"
              cols="12"
              sm="6"
              md="5"
            >
              <v-img
                src="/images/learning/mentoring.jpg"
                alt=""
                aspect-ratio="1.7778"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="7">
              <v-icon x-large class="mb-3">fal fa-head-side-headphones</v-icon>
              <h3 class="text-h5 font-weight-bold mb-3">
                Mentoring
              </h3>
              <p class="mb-0 text-body-1">
                We all have to start somewhere and whether you are a novice photographer or a seasoned veteran wanting to gain new perspective, finding a mentor is of critical importance if we are to grow.
              </p>
              <v-btn
                to="#"
                nuxt
                class="mt-4 grey darken-4 white--text"
                depressed
                outlined
              >
                Feature coming soon
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'LearningFeatures'
}
</script>
